import FileDownloadButton from '@cp/src/components/Buttons/FileDownloadButton';
import { Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import styles from '../index.module.scss';

const ExperimentsData = (props: { experimentsData: string }) => {
  const { experimentsData } = props;
  return (
    <div className={cx(styles.headerContainer, 'mt-4 rounded-[7px]')}>
      <Typography variant="h4" color="var(--grayscale-3)">
        Experiment LANs
      </Typography>
      <FileDownloadButton
        label="Download"
        presignedUrl={experimentsData}
        fileName="Experiments Data"
      />
    </div>
  );
};

export default ExperimentsData;
